import { useSelector } from 'react-redux';
import { StatusLabelModel } from '../../../models/grid.model';
import * as selector from "../../../selectors/selectors"
interface IProps extends StatusLabelModel {
}

export const StatusRenderer = (props: IProps) => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    return (
        <span className={`status-variant-${props.Variant} ${props.ClassName} ${IsDarkMode && props.Variant !== "danger" ? "inverted" : ""}`} key={props.Id}>
            {props.Label}
        </span>
    );
};
